var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlant = function SvgPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18A87D",
    d: "M13.036 5.036v1.482a3.85 3.85 0 0 1-3.852 3.852H7.703v2.963H6.517V9.185l.012-.593a3.85 3.85 0 0 1 3.84-3.556zm-9.482-2.37a4.15 4.15 0 0 1 3.937 2.836 4.43 4.43 0 0 0-1.556 3.09h-.603a4.15 4.15 0 0 1-4.148-4.148V2.666z"
  })));
};
export default SvgPlant;